var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys } from "vue";
const _hoisted_1 = {
    id: "job-modal",
    class: "modal type1 js-modal"
};
const _hoisted_2 = { class: "modal-content" };
const _hoisted_3 = { class: "close_bt bt_modal_close" };
const _hoisted_4 = { class: "pop" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = ["value", "id", "onChange"];
const _hoisted_7 = ["for"];
const _hoisted_8 = { key: 1 };
const _hoisted_9 = ["checked"];
const _hoisted_10 = {
    key: 0,
    class: "err"
};
const _hoisted_11 = {
    key: 1,
    class: "err"
};
const _hoisted_12 = { class: "bt_box clear" };
const _hoisted_13 = { class: "modalBtn-area" };
import { ref, reactive, watch, onBeforeMount } from 'vue';
import Alert from '@util/BrowserAlert';
import ImageFrame from '@component/ImageFrame.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'JobModal',
    props: {
        options: { default: [] },
        form: {},
        errors: {},
        placeholder: {}
    },
    emits: ['selected', 'cancel'],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const form = reactive({
            job_group_id: '',
            job_group_name: '',
            job_id: '',
            job_name: '',
            other_job_name: '',
        });
        const close = ref();
        // 文字数チェック
        watch(() => form.other_job_name, (value) => {
            if (Alert.charLimitText(value)) {
                form.other_job_name = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        // ラジオ選択
        const onSelectedJob = (jobGroupId, jobId) => {
            form.job_group_id = jobGroupId;
            form.job_id = jobId;
        };
        // キャンセルボタン
        const onClickCancel = () => {
            var _a, _b, _c, _d, _e;
            setSelectedName((_b = (_a = props.form) === null || _a === void 0 ? void 0 : _a.job_group) === null || _b === void 0 ? void 0 : _b.id, (_d = (_c = props.form) === null || _c === void 0 ? void 0 : _c.job) === null || _d === void 0 ? void 0 : _d.id, (_e = props.form) === null || _e === void 0 ? void 0 : _e.other_job_name);
            emit('cancel');
        };
        // クリアボタン
        const onClickClear = () => {
            form.job_group_id = null;
            form.job_group_name = '';
            form.job_id = null;
            form.job_name = '';
            form.other_job_name = '';
            // 全てのチェックを外す
            const radio = document.getElementsByName('job_q1');
            radio.forEach((el) => {
                el.checked = false;
            });
        };
        // OKボタン
        const onClickOK = () => {
            setSelectedName(form.job_group_id, form.job_id, form.other_job_name);
            emit('selected', Object.assign({}, form));
        };
        const onCloseModal = () => {
            close.value.click();
        };
        // 選択内容を表示用の値に入れ込む
        const setSelectedName = (groupId, jobId, otherJobName) => {
            if ((groupId === '' || groupId === null || jobId === '' || jobId === null) && otherJobName === '') {
                form.job_group_name = '';
                form.job_name = '';
                form.other_job_name = '';
            }
            else {
                if (jobId !== '') {
                    const group = props.options.find((value) => value.id === groupId);
                    const job = group === null || group === void 0 ? void 0 : group.jobs.find((value) => value.id === jobId);
                    if (group && job) {
                        form.job_group_name = group.name;
                        form.job_name = job.name;
                        form.other_job_name = '';
                    }
                    else {
                        form.job_group_name = '';
                        form.job_name = '';
                        form.other_job_name = '';
                    }
                }
                else {
                    form.job_group_name = 'その他';
                    form.job_name = '';
                    form.other_job_name = otherJobName;
                }
            }
        };
        onBeforeMount(() => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            form.job_group_id = (_b = (_a = props.form) === null || _a === void 0 ? void 0 : _a.job_group_id) !== null && _b !== void 0 ? _b : null;
            form.job_group_name = (_d = (_c = props.form) === null || _c === void 0 ? void 0 : _c.job_group_name) !== null && _d !== void 0 ? _d : '';
            form.job_id = (_f = (_e = props.form) === null || _e === void 0 ? void 0 : _e.job_id) !== null && _f !== void 0 ? _f : null;
            form.job_name = (_h = (_g = props.form) === null || _g === void 0 ? void 0 : _g.job_name) !== null && _h !== void 0 ? _h : '';
            form.other_job_name = (_k = (_j = props.form) === null || _j === void 0 ? void 0 : _j.other_job_name) !== null && _k !== void 0 ? _k : '';
        }));
        const openModal = (obj) => {
            var _a, _b, _c, _d, _e;
            form.job_group_id = (_a = obj === null || obj === void 0 ? void 0 : obj.job_group_id) !== null && _a !== void 0 ? _a : null;
            form.job_group_name = (_b = obj === null || obj === void 0 ? void 0 : obj.job_group_name) !== null && _b !== void 0 ? _b : '';
            form.job_id = (_c = obj === null || obj === void 0 ? void 0 : obj.job_id) !== null && _c !== void 0 ? _c : null;
            form.job_name = (_d = obj === null || obj === void 0 ? void 0 : obj.job_name) !== null && _d !== void 0 ? _d : '';
            form.other_job_name = (_e = obj === null || obj === void 0 ? void 0 : obj.other_job_name) !== null && _e !== void 0 ? _e : '';
        };
        __expose({
            openModal,
            onCloseModal,
        });
        return (_ctx, _cache) => {
            var _a, _b;
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: "modal-bg bt_modal_close",
                    onClick: onClickCancel
                }),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(ImageFrame, {
                            src: "images/common/i_bt_close.svg",
                            onClick: onClickCancel
                        })
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _cache[9] || (_cache[9] = _createElementVNode("h2", null, "職種を選択してください", -1)),
                        _createElementVNode("dl", null, [
                            _cache[7] || (_cache[7] = _createElementVNode("dt", null, "職種分類", -1)),
                            _cache[8] || (_cache[8] = _createElementVNode("dd", null, "職種", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (groups) => {
                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                    _createElementVNode("dt", null, _toDisplayString(groups.name), 1),
                                    (groups.id)
                                        ? (_openBlock(), _createElementBlock("dd", _hoisted_5, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groups.jobs, (job) => {
                                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((form.job_id) = $event)),
                                                        value: job.id,
                                                        class: "visually-hidden",
                                                        type: "radio",
                                                        name: "job_q1",
                                                        id: `job_q1_a${job.id}`,
                                                        onChange: ($event) => (onSelectedJob(groups.id, job.id))
                                                    }, null, 40, _hoisted_6), [
                                                        [_vModelRadio, form.job_id]
                                                    ]),
                                                    _createElementVNode("label", {
                                                        for: `job_q1_a${job.id}`
                                                    }, _toDisplayString(job.name), 9, _hoisted_7)
                                                ], 64));
                                            }), 256))
                                        ]))
                                        : (_openBlock(), _createElementBlock("dd", _hoisted_8, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((form.job_id) = $event)),
                                                value: "",
                                                class: "visually-hidden",
                                                type: "radio",
                                                name: "job_q1",
                                                id: "job_q1_a_other",
                                                onChange: _cache[2] || (_cache[2] = ($event) => (onSelectedJob('', ''))),
                                                checked: props.form.other_job_name != ''
                                            }, null, 40, _hoisted_9), [
                                                [_vModelRadio, form.job_id]
                                            ]),
                                            _cache[6] || (_cache[6] = _createElementVNode("label", { for: "job_q1_a_other" }, "その他", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((form.other_job_name) = $event)),
                                                class: "modal-form wmax",
                                                type: "text",
                                                placeholder: "(職種名を入力ください)",
                                                onInput: _cache[4] || (_cache[4] = ($event) => (form.job_group_id = form.job_id = '')),
                                                onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event) => (_ctx.void), ["prevent"]), ["enter"]))
                                            }, null, 544), [
                                                [_vModelText, form.other_job_name]
                                            ])
                                        ]))
                                ], 64));
                            }), 256)),
                            ((_a = props === null || props === void 0 ? void 0 : props.errors) === null || _a === void 0 ? void 0 : _a.job_id)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(props === null || props === void 0 ? void 0 : props.errors.job_id), 1))
                                : _createCommentVNode("", true),
                            ((_b = props === null || props === void 0 ? void 0 : props.errors) === null || _b === void 0 ? void 0 : _b.other_job_name)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(props === null || props === void 0 ? void 0 : props.errors.other_job_name), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("ul", _hoisted_13, [
                                _createElementVNode("li", null, [
                                    _createElementVNode("button", {
                                        class: "bt_clear",
                                        onClick: _withModifiers(onClickClear, ["prevent"])
                                    }, "クリア")
                                ]),
                                _createElementVNode("li", null, [
                                    _createElementVNode("p", {
                                        class: "bt_modal_close bt_clear",
                                        onClick: onClickCancel
                                    }, "キャンセル")
                                ]),
                                _createElementVNode("li", null, [
                                    _createElementVNode("p", {
                                        class: "bt_ok",
                                        onClick: onClickOK
                                    }, "OK")
                                ])
                            ]),
                            _createElementVNode("p", {
                                class: "bt_modal_close",
                                ref_key: "close",
                                ref: close,
                                style: { "display": "none" }
                            }, null, 512)
                        ])
                    ])
                ])
            ]));
        };
    }
});
